module.exports = __webpack_public_path__ + "static/media/img5.67f5822d.jpeg";